import React from "react";

import SidebarCollapser from './sidebar.collapser.component';
import SidebarHeader from './sidebar.header.component';
import SidebarModules from './sidebar.modules.component';
import SidebarFinishes from './sidebar.finishes.component';

interface Props {
  showIntro: boolean,
  isCollapsed: boolean;
  propertyType: any;
  module1: any;
  module2: any;
  module3: any;
  module4: any;
  finishesRail: any;
  finishesFloor: any;
  finishesMeson: any;
  finishesWoodwork: any;
  modulesCompleted: boolean;
  showAlternative: string;
  allFinishesUpdated: any;
  allModulesUpdated: any;
  setModule1: (value: any) => void;
  setModule2: (value: any) => void;
  setModule3: (value: any) => void;
  setModule4: (value: any) => void;
  setFinishesRail: (value: any) => void;
  setFinishesFloor: (value: any) => void;
  setFinishesMeson: (value: any) => void;
  setFinishesWoodwork: (value: any) => void;
  setIsCollapsed: (boolean: any) => void;
  setShowAlternative: (value: any) => void;
  setModulesCompleted: (boolean: any) => void;
}

const Sidebar: React.FC<Props> = ({showIntro, isCollapsed, module1, module2, module3, module4, finishesRail, finishesFloor, finishesMeson, finishesWoodwork, propertyType, modulesCompleted, showAlternative, allFinishesUpdated, allModulesUpdated, setIsCollapsed, setModule1, setModule2, setModule3, setModule4, setFinishesRail, setFinishesFloor, setFinishesMeson, setFinishesWoodwork, setModulesCompleted, setShowAlternative }) => {
  
  const [showTutorial, setShowTutorial] = React.useState(true);
  const [isMouseGrabbing, setIsMouseGrabbing] = React.useState(false);

  const refBar = React.useRef<HTMLDivElement>(null);
  const isDown = React.useRef(false);
  const startY = React.useRef(0);
  const scrollTop = React.useRef(0);

  const onMouseDown = (e: React.MouseEvent) => {
    if (!refBar.current) return;
    isDown.current = true;
    setIsMouseGrabbing(true);
    startY.current = e.pageY - refBar.current.offsetTop;
    scrollTop.current = refBar.current.scrollTop;
  };

  const onMouseLeave = () => {
    isDown.current = false;
    setIsMouseGrabbing(false);
  };

  const onMouseUp = () => {
    isDown.current = false;
    setIsMouseGrabbing(false);
  };

  const onMouseMove = (e: React.MouseEvent) => {
    if (!isDown.current || !refBar.current) return;
    e.preventDefault();
    const y = e.pageY - refBar.current.offsetTop;
    const walk = (y - startY.current) * 1;
    refBar.current.scrollTop = scrollTop.current - walk;
  };

  return (
    <div className={`tour-full-siderbar ${showIntro === true ? 'hide':''}`}>
      <div className={`tour-sidebar-container ${(isCollapsed) ? 'collapsed':''}`}>
        <SidebarHeader title="PERSONALIZA"/>
        <div ref={refBar} className="tour-sidebar-subcontainer" style={{cursor: isMouseGrabbing ? "grabbing" : "unset"}} onMouseDown={onMouseDown} onMouseLeave={onMouseLeave} onMouseUp={onMouseUp}onMouseMove={onMouseMove}>
          <SidebarModules propertyType={propertyType} module1={module1} module2={module2} module3={module3} module4={module4} modulesCompleted={modulesCompleted} showAlternative={showAlternative} allModulesUpdated={allModulesUpdated} setShowAlternative={setShowAlternative} setModule1={setModule1} setModule2={setModule2} setModule3={setModule3} setModule4={setModule4} setModulesCompleted={setModulesCompleted}/>
          <SidebarFinishes propertyType={propertyType} finishesRail={finishesRail} finishesFloor={finishesFloor} finishesMeson={finishesMeson} finishesWoodwork={finishesWoodwork} allFinishesUpdated={allFinishesUpdated} setFinishesRail={setFinishesRail} setFinishesFloor={setFinishesFloor} setFinishesMeson={setFinishesMeson} setFinishesWoodwork={setFinishesWoodwork}/>
        </div>
        <SidebarCollapser isCollapsed={isCollapsed} showTutorial={showTutorial} setIsCollapsed={setIsCollapsed} setShowTutorial={setShowTutorial}/>
      </div>
      
    </div>
  );
};

export default Sidebar;
